<template>
    <button class="default-button" :class="{ 'default-button--secondary': isSecondary, 'default-button--red': isRed }"
        @click="press" :disabled="disabled || loading">
        {{ text }}
        <div v-if="loading" class="default-button__loader"></div>
    </button>
</template>

<script>
export default {
    name: 'DefaultButton',

    props: {
        text: {
            type: String,
        },
        isSecondary: {
            type: Boolean,
            default: false
        },
        isRed: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        press() {
            if (!this.disabled) {
                this.$emit('press')
            }
        }
    }
}
</script>

<style lang="scss">
.default-button {
    box-sizing: border-box;
    border: none;
    border-radius: 18px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    max-width: 300px;
    border: 1px solid var(--color-btn);

    cursor: pointer;

    background-color: var(--color-btn);
    color: var(--color-btn-text);
    transition: all 0.2s ease;

    font-weight: 600;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    &--secondary {
        background-color: var(--color-bg-dark);
        color: var(--color-btn-text-secondary);
    }

    &--red {
        background-color: var(--color-red);
        color: var(--color-btn);

        &:hover {
            background-color: var(--color-red-light) !important;
        }
    }

    &:hover {
        background-color: var(--color-btn-hover);
    }

    &:active {
        background-color: var(--color-btn-active);
    }

    &__loader {
        width: 16px;
        height: 16px;
        border: 2px solid currentColor;
        border-bottom-color: transparent;
        border-radius: 50%;
        animation: rotate 1s linear infinite;
    }
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
